<script setup lang="ts">
import type { TpgSelectEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarBreadcrumbsProps {
  trailingMenu?: boolean;
  trailingMenuIconTemplate?: IconConstant | '';
  manualScroll?: boolean;
}

interface GrammarBreadcrumbsSlots {
  default?: Slot;
  action?: Slot;
}

const props = withDefaults(defineProps<GrammarBreadcrumbsProps>(), {
  trailingMenu: false,
  trailingMenuIconTemplate: '',
  manualScroll: false,
});

const emit = defineEmits(['select', 'scrollUp', 'scrollDown']);
const slots = defineSlots<GrammarBreadcrumbsSlots>();
function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}

function onScrollUp() {
  emit('scrollUp');
}
function onScrollDown() {
  emit('scrollDown');
}
</script>

<template>
  <tpg-breadcrumbs
    v-bind="props"
    @tpg-select="onSelect"
    @tpg-scroll-down="onScrollDown"
    @tpg-scroll-up="onScrollUp"
  >
    <slot />
    <div v-if="slots.action" slot="action">
      <slot name="action" />
    </div>
  </tpg-breadcrumbs>
</template>
